import {envUtil} from '@px/helper';
import {guid} from '@px/helper/guid';
import cookies from 'js-cookie';

const BID_KEY = 'p_b_i_d';
const COOKIE_BID_KEY = 'px_bid';

export function readBid(): string {
  if (envUtil.isApp) {
    return window.navigator.userAgent.split(' ')[3];
  }

  const bid = localStorage.getItem(BID_KEY);
  if (bid && bid.length === 36) {
    writeBidToCookie(bid);
    return bid;
  }

  const newBid = guid.build();
  localStorage.setItem(BID_KEY, newBid);
  writeBidToCookie(newBid);
  return newBid;
}

function writeBidToCookie(bid) {
  cookies.set(COOKIE_BID_KEY, bid);
}
